import {useItemStore} from "@/stores/items";

export const parseHashPath = (path: string) => {
    const itemStore = useItemStore();
    let nr = 0;
    for (const value of path.substring(1).split('/')) {
        switch (nr++) {
            case 0:
                itemStore.setFilters(value,true);
                break;
            case 1:
                itemStore.setFilters(value,false);
                break;
        }
    }
}